import React, { useEffect, useState } from 'react'
import './SubMenu.scss'
import ScrollspyNav from 'react-scrollspy-nav'

export default function SubMenu({ blocks, id }) {

	const [collapsed, setCollapsed] = useState(true)

	let sections = [];
	blocks.forEach((item, i) => {
		if (item.subMenuName) {
			sections.push(`${id}_${i}`)
		}
	})

	useEffect(() => {
		const pinToTop = e => {
			if (typeof window !== `undefined`) {
				if (document.documentElement.scrollTop > window.innerHeight - 200) {
					document.getElementById('subMenu').classList.add('sticky')
				} else {
					document.getElementById('subMenu').classList.remove('sticky')
				}
			}
		}

		// const setAutoCollapse = () => {
		// 	if (typeof window !== `undefined`) {
		// 		if (window.innerWidth < 900) {
		// 			setCollapsed(true)
		// 		} else {
		// 			setCollapsed(false)
		// 		}
		// 	}
		// }

		if (typeof window !== `undefined`) {
			//window.addEventListener('resize', setAutoCollapse)
			window.addEventListener('scroll', pinToTop)
			//setAutoCollapse()
			return () => {
				window.removeEventListener('scroll', pinToTop)
			}
		}

	},[])


	return (
		<nav className="SubMenu" data-collapsed={collapsed} id="subMenu">
			<h1 className="screen-reader-only">Hopp til seksjoner</h1>
			<ScrollspyNav scrollTargetIds={sections} activeNavClass="active" scrollDuration={800} offset={-140}>
				<div className="inner">
					<button aria-expanded={!collapsed} className={collapsed ? 'active' : ''} onClick={() => setCollapsed(!collapsed)}>
						<svg xmlns="http://www.w3.org/2000/svg" width="6.521" height="6.082" viewBox="0 0 6.521 6.082">
							<path d="M5.388,10.546,7.242,9.087,5.388,7.628V6.046L8.227,8.252v1.67L5.388,12.128Zm-3.683,0L3.56,9.087,1.705,7.628V6.046l2.83,2.206v1.67l-2.83,2.206Z" transform="translate(-1.705 -6.046)" />
						</svg>
						Lukk
					</button>
					<ul aria-hidden={collapsed}>
						{
							blocks.map((item, i) => {
								if (item.subMenuName) {
									return (
										<li key={`${id}_${i}`}>
											<a href={`#${id}_${i}`}>{item.subMenuName}</a>
										</li>
									)
								}
								return null
							})
						}
					</ul>
				</div>
			</ScrollspyNav>
		</nav>
	)
}